export default "__VITE_ASSET__Du1DyCB4__"